module.exports = __webpack_public_path__ + "static/scale-model-of-barbie-pond-on-avenue-q-in-alexandria-virginia-c5c7b0cfcfb8586b5c372ffc0e713d46.png";